import PageLayout from "../components/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import styles from "./pages.module.css";

export default function Home() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <PageLayout>
            <section className={styles.invitationSection}>
                <h2 className={styles.title}>{t("home.inviteTitle")}</h2>
                <p className={styles.text}>{t("home.inviteText1")}</p>
                <p className={styles.text}>{t("home.inviteText2")}</p>
                <button className={styles.button} onClick={() => navigate("/surveys")}> {t("home.goToSurveys")}</button>
                <p className={styles.text}>{t("home.inviteText3")}</p>
                <div className={styles.surveyListSimple}>
                    <Link to="/surveys/ff4b576c-7fac-485b-9b59-861b3d1446f7" className={`${styles.surveyItem} ${styles.surveyLink}`}>{t("home.survey1")}</Link>
                    <Link to="/surveys/7baac642-b00c-4200-bbc9-b08e45766acd" className={`${styles.surveyItem} ${styles.surveyLink}`}>{t("home.survey2")}</Link>
                    <Link to="/surveys/7639d3a6-2ca0-47bc-889b-19c200eef1eb" className={`${styles.surveyItem} ${styles.surveyLink}`}>{t("home.survey3")}</Link>
                    <Link to="/surveys/7a2665ea-36cd-4566-be4b-751a77ec15b5" className={`${styles.surveyItem} ${styles.surveyLink}`}>{t("home.survey4")}</Link>
                </div>
                <p className={styles.text}>{t("home.inviteText4")}</p>
                <p className={styles.text}>{t("home.inviteText5")}</p>
            </section>

            <section className={styles.section}>
                <h3 className={styles.title}>{t("home.instructionsTitle")}</h3>
                <ul>
                    <li>{t("home.instructionsItem1")}</li>
                    <li>{t("home.instructionsItem2")}</li>
                    <li>{t("home.instructionsItem3")}</li>
                </ul>
                <p className={styles.text}>{t("home.instructionsText")}</p>
            </section>

            <section className={styles.section}>
                <h3 className={styles.title}>{t("home.anonTitle")}</h3>
                <ul>
                    <li>{t("home.anonItem1")}</li>
                    <li>{t("home.anonItem2")}</li>
                    <li>{t("home.anonItem3")}</li>
                    <li>{t("home.anonItem4")}</li>
                    <li>{t("home.anonItem5")}</li>
                </ul>
                <button className={styles.button} onClick={() => navigate("/privacy")}>{t("home.anonLink")}</button>
            </section>

            <section className={styles.section}>
                <h3 className={styles.title}>{t("home.aboutTitle")}</h3>
                <p className={styles.text}>{t("home.aboutText")}</p>
                <button className={styles.button} onClick={() => navigate("/about")}>{t("home.aboutLink")}</button>
            </section>
        </PageLayout>
    );
}